import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import {
  IndicatorSpeciesChartData,
  IndicatorSpeciesHistoricalChart,
} from '@/pages/shared/projects/pages/project/pages/conservation/BU/components/Charts/IndicatorSpeciesHistorical';
import { useGetConservationBenchmarks } from '@/pages/shared/projects/pages/project/pages/conservation/BU/hooks/useGetConservationBenchmarks';
import { useGetTrendLabel } from '@/pages/shared/projects/pages/project/pages/conservation/BU/hooks/useGetTrendLabel';
import { getBenchmarkForConservationFact } from '@/pages/shared/projects/pages/project/pages/conservation/BU/utils/getBenchmarkForConservationFact';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

export const GraphTile = () => {
  const { t } = useTranslation();

  const projectAverage = useFact<number>('r1_conservation_indicator_species_score');
  const benchmarks = useGetConservationBenchmarks();
  const benchmark = getBenchmarkForConservationFact({
    fact: projectAverage,
    benchmarks,
  });

  const trendLabel = useGetTrendLabel({
    trendChangeFact: 'r1_conservation_indicator_species_change_percentage',
  });

  const indicatorSpeciesTimeseries = useFact<{ value: Record<string, number> }>('r1_conservation_indicator_species_ts');
  const baselineYear = useFact<number>('r1_conservation_indicator_species_baseline_year').value;

  const chartData: IndicatorSpeciesChartData[] = Object.entries(indicatorSpeciesTimeseries.value).map(
    ([year, value]) => {
      const indicatorSpeciesValue = typeof value === 'number' ? value : 0;

      return {
        indicatorSpeciesBar: indicatorSpeciesValue,
        indicatorSpeciesLine: indicatorSpeciesValue,
        date: new Date(year),
        benchmark: benchmark ? benchmarks[`${benchmark}`] : null,
      };
    },
  );

  return (
    <Stack center spacing={6} data-testid='indicator-species-graph-tile'>
      <ChartHeading
        heading={t('shared.ncaDetail.indicatorSpecies.evolution.chartHeading', { year: baselineYear })}
        className='w-full px-6 sm:px-0'
      />
      <IndicatorSpeciesHistoricalChart data={chartData} benchmark={benchmark} trendLabel={trendLabel} />
    </Stack>
  );
};
